import checkStatus from '../utils/checkStatus';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import api from '../utils/api';
import JwtStore from './JwtStore';
import dispatchHttpError from '../utils/dispatchHttpError';

export default {
  fetch() {
    return fetch(api('timeless'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      }
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.CATEGORY_STORE_FETCH_COMPLETE,
        categories: response.data,
      }))
      .catch(dispatchHttpError);
  },
  fetchById(id) {
    return fetch(api(`timeless/${id}`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.CATEGORY_BY_ID_STORE_FETCH_COMPLETE,
        category: response.data,
      }))
      .catch(dispatchHttpError);
  },
}
